import { httpsCallableFromURL } from 'firebase/functions';
import { functions, httpsCallableCloudUrl } from '../config/firebase';

const linkPocketDealRecipientFn = httpsCallableFromURL(
  functions,
  httpsCallableCloudUrl('linkPocketDealRecipient'),
);

/**
 * Link authenticated user to broker client doc after opening a pocket deal share (email + share owner must match).
 * @param {{ shareToken: string, clientId: string }} params
 */
/** @param {unknown} e */
export function pocketLinkErrorReason(e) {
  const d = e?.details ?? e?.customData;
  return typeof d?.reason === 'string' ? d.reason : null;
}

export async function linkPocketDealRecipient(params) {
  try {
    const { data } = await linkPocketDealRecipientFn(params);
    return data;
  } catch (e) {
    const details = e?.details ?? e?.customData;
    console.warn('linkPocketDealRecipient failed', e?.code, e?.message, details);
    throw e;
  }
}
